/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ServiceAdvisorPerformanceController {
        public static $inject: string[] = [
            '$mobilityCompanyAuthentication',
            '$dealerwareLookerService',
            '$dealerwareNotification',
            'DealerwareEmployeeModel',
            '$dealerwareInternationalizationData'
        ];

        public _dateRangeDisplay: string;

        public collapsed: boolean;
        public showSettings: boolean;
        public loading: boolean;
        public data: any;
        public totals: any;
        public dateRangeType: string = 'last';
        public times: number = 30;
        public interval: string = 'days';
        public startDate: Date = new Date();
        public endDate: Date = new Date();
        public timeZone = '';
        public labels            : {};

        constructor(public $auth: any, public lookerService: any, public $dealerwareNotification: any, public DealerwareEmployeeModel: any, public $dealerwareInternationalizationData: any) {

            this.getLabels('dashboard');
            this.timeZone = this.$auth.location.time_zone_name;
            this.loadData();
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
            .getLabels()
            .then( function(res) {
                _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                _self.updateDateRangeDisplay();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        private get dateRange() : any {
            if (this.dateRangeType === 'last') {
                return {
                    start: moment().subtract(this.times, this.interval).tz(this.timeZone).format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'day').tz(this.timeZone).format('YYYY-MM-DD')
                };
            } else {
                return {
                    start: moment(this.startDate).tz(this.timeZone).format('YYYY-MM-DDT00:00:00'),
                    end: moment(this.endDate).add(1, 'day').tz(this.timeZone).format('YYYY-MM-DDT23:59:59')
                };
            }
        }

        private get dateRangeDisplay() : string {
            return this._dateRangeDisplay;
        }

        private updateDateRangeDisplay() : void {
            if (this.dateRangeType === 'last') {
                this._dateRangeDisplay = `${this.labels ? this.labels.serviceAdvisor.in_the : "" } ${this.labels ? this.labels.serviceAdvisor.last : ""} ${this.times} ${this.labels ? this.labels.serviceAdvisor.days : ""}`;
            } else {
                this._dateRangeDisplay = `${this.labels ? this.labels.serviceAdvisor.between : ""} ${this.dateRange.start} ${this.dateRange.end}`;
            }
        }

        public toggleCollapsed() : void {
            this.collapsed = !this.collapsed;
        }

        public toggleSettings() : void {
            this.showSettings = !this.showSettings;
        }

        public loadData() : void {
            var _self = this;
            this.data = undefined;
            this.loading = true;
            this.showSettings = false;
            this.DealerwareEmployeeModel.getServiceAdvisorStatistics({
                promise: true,
                params: {
                    location_id     : this.$auth.location.id,
                    sort_by         : 'service_advisor_id',
                    sort_direction  : 'asc',
                    start_date      : this.dateRange.start,
                    end_date        : this.dateRange.end
                }
            }).then(
                ( response: any ) => {
                    _self.parseData(response.data);
                    _self.updateDateRangeDisplay();
                }
            ).finally(
                () => {
                    _self.loading = false;
                }
            );
        };

        public static getTimeBucket = (lengthOfLoan: number) : string => {
            /* if for some reason the contract doesn't have an actual pickup or drop off date,
            it would be a 0-1 day rental*/
            if (lengthOfLoan < 2 || !lengthOfLoan) return 'zero_to_one';
            if (lengthOfLoan < 4) return 'two_to_three';
            if (lengthOfLoan < 6) return 'four_to_five';
            if (lengthOfLoan < 11) return 'six_to_ten';
            return 'eleven_plus';
        };

        public static initialMetrics = (name?:string) : object => {
            const metricsObj = {
                total_lol: 0,
                contracts:0,
                zero_to_one: 0,
                two_to_three: 0,
                four_to_five: 0,
                six_to_ten: 0,
                eleven_plus: 0,
            };

            if (name) {
                metricsObj['name'] = name;
            }
            return metricsObj;
        };

        public parseData(data: any) {
            /* loops through data from service advisor call,
              and based on the length of loan (lol) adds to the contract count to the
              appropriate time bucket for the individual service advisor totals and
              for the totals across all service advisors */

            // future TODO: move this functionality to the BE so that the length of loan logic is consistent
            const { serviceAdvisorData, totals } = data.reduce((acc, contract) => {
                const lengthOfLoan = moment(contract['actual_dropoff']).diff(moment(contract['actual_pickup']), 'minutes') / 60 / 24;
                const { service_advisor_id, service_advisor_name } = contract;

                const serviceAdvisorMetrics = acc['serviceAdvisorData'][service_advisor_id]
                    || ServiceAdvisorPerformanceController.initialMetrics(service_advisor_name);
                const totals = acc['totals'];

                const timeBucket = ServiceAdvisorPerformanceController.getTimeBucket(lengthOfLoan);
                // add 1 to current time bucket on the service advisor metric count and total counts
                serviceAdvisorMetrics[timeBucket] += 1;
                totals[timeBucket] += 1;
                // add lol to total lol on the service advisor metric count and total counts
                serviceAdvisorMetrics['total_lol'] += lengthOfLoan;
                totals['total_lol'] += lengthOfLoan;
                // add to total contract on the service advisor metric count and total counts
                serviceAdvisorMetrics['contracts'] += 1;
                totals['contracts'] += 1;

                acc['serviceAdvisorData'][service_advisor_id] = serviceAdvisorMetrics;
                return acc;
            },{serviceAdvisorData: {}, totals: ServiceAdvisorPerformanceController.initialMetrics()});

            this.data = data.length ? serviceAdvisorData : undefined;
            this.totals = totals;
        }
    }

    getDealerwareWebComponentsModule().controller('ServiceAdvisorPerformanceController', ServiceAdvisorPerformanceController);

    export class ServiceAdvisorPerformanceDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ServiceAdvisorPerformanceController';
        public controllerAs     : string    =   'serviceAdvisorPerformanceController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/dashboard_widgets/service_advisor_performance/service_advisor_performance_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive('dealerwareServiceAdvisorPerformance', () => new ServiceAdvisorPerformanceDirective());
}
